import BlogArticleTemplate from '../../components/BlogArticleTemplate.tsx';

const articleData = {
  meta: {
    title: 'Creare Sito Web per Ristorante: Costi e Funzionalità [Guida 2025]',
    description: 'Sito web per ristorante da €1.200. Menu digitale, prenotazioni online, gallery. Guida completa: cosa serve, quanto costa, come aumentare le prenotazioni.',
    keywords: 'creare sito web per ristorante, sito web ristorante, sito per ristoranti, sito web pizzeria, sito web trattoria, menu digitale ristorante, costo sito ristorante',
    ogTitle: 'Creare Sito Web per Ristorante: Costi e Funzionalità',
    ogDescription: 'Sito web per ristorante da €1.200. Menu digitale, prenotazioni online, gallery e SEO locale.',
    slug: 'sito-web-per-ristoranti-guida-completa',
    publishedDate: '2025-02-20',
    category: 'Settore Food',
    readTime: '9 min',
    heroImage: '/sfondi/blog.png',
    heroImageAlt: 'Sito Web per Ristoranti',
    excerpt: 'Tutto quello che serve per creare un sito web efficace per il tuo ristorante: funzionalità essenziali, costi reali e strategie per aumentare le prenotazioni.'
  },

  toc: [
    { id: 'perche', label: 'Perché Serve un Sito' },
    { id: 'funzionalita', label: 'Funzionalità Essenziali' },
    { id: 'avanzate', label: 'Funzionalità Avanzate' },
    { id: 'costi', label: 'Quanto Costa' },
    { id: 'seo', label: 'SEO Locale' },
    { id: 'conclusione', label: 'Conclusione' }
  ],

  sectionOneContent: (
    <>
      <p>
        Nel 2025, <strong>un ristorante senza sito web</strong> è praticamente invisibile. L'85% delle persone cerca online prima di scegliere dove mangiare, e se il tuo ristorante non appare o ha un sito obsoleto, stai perdendo clienti ogni giorno.
      </p>

      <p>
        In questa guida ti spiego <strong>come creare un sito web per ristorante</strong> che funziona: cosa deve avere, quanto costa e come può aumentare le tue prenotazioni.
      </p>

      <h2 id="perche">Perché un Ristorante Ha Bisogno di un Sito Web?</h2>

      <div className="info-box">
        <ul>
          <li><strong>Visibilità locale:</strong> Quando qualcuno cerca "ristorante + città" su Google, vuoi apparire tu</li>
          <li><strong>Prima impressione:</strong> Il 75% delle persone giudica un'attività dal suo sito web</li>
          <li><strong>Menu sempre aggiornato:</strong> Mostri piatti, prezzi e allergeni in tempo reale</li>
          <li><strong>Prenotazioni dirette:</strong> Eviti le commissioni delle piattaforme (TheFork, TripAdvisor)</li>
          <li><strong>Credibilità:</strong> Un sito professionale trasmette qualità e cura del dettaglio</li>
        </ul>
      </div>

      <div className="info-box highlight">
        <h3>Dato Interessante</h3>
        <p>
          I ristoranti con un sito web professionale ricevono in media il <strong>30% in più di prenotazioni</strong> rispetto a quelli presenti solo sui social o su piattaforme terze.
        </p>
      </div>
    </>
  ),

  parallaxBoxes: [
    {
      title: 'Menu Digitale Completo',
      content: (
        <>
          <p id="funzionalita">Il <strong>menu è l'elemento più importante</strong> del sito. Deve essere:</p>
          <ul>
            <li><strong>Facile da leggere:</strong> Categorie chiare (antipasti, primi, secondi, dolci)</li>
            <li><strong>Aggiornabile:</strong> Modifichi piatti e prezzi in autonomia</li>
            <li><strong>Con allergeni:</strong> Obbligatorio per legge, utile per i clienti</li>
            <li><strong>Con foto (opzionale):</strong> Le foto aumentano l'appetibilità</li>
            <li><strong>Scaricabile in PDF:</strong> Per chi preferisce il formato classico</li>
          </ul>
        </>
      )
    },
    {
      title: 'Sistema di Prenotazione',
      content: (
        <>
          <p>Le opzioni per le <strong>prenotazioni online</strong>:</p>
          <ul>
            <li><strong>Form semplice:</strong> Nome, data, ora, numero persone → email al ristorante</li>
            <li><strong>Widget integrato:</strong> TheFork, Quandoo o simili (con commissioni)</li>
            <li><strong>Sistema proprietario:</strong> Gestione prenotazioni custom</li>
            <li><strong>WhatsApp Business:</strong> Link diretto per prenotare via chat</li>
          </ul>
        </>
      )
    },
    {
      title: 'Informazioni di Contatto',
      content: (
        <>
          <p>Devono essere <strong>immediatamente visibili</strong>:</p>
          <ul>
            <li><strong>Indirizzo:</strong> Con link a Google Maps per le indicazioni</li>
            <li><strong>Telefono:</strong> Cliccabile su mobile per chiamare subito</li>
            <li><strong>Orari di apertura:</strong> Aggiornati (anche per festività)</li>
            <li><strong>Email:</strong> Per richieste e prenotazioni gruppi</li>
          </ul>
        </>
      )
    },
    {
      title: 'Galleria e Chi Siamo',
      content: (
        <>
          <p>Le foto giuste e la storia fanno la differenza:</p>
          <ul>
            <li><strong>Piatti:</strong> Foto professionali dei piatti signature</li>
            <li><strong>Locale:</strong> Interni, esterni, atmosfera</li>
            <li><strong>Team:</strong> Chef, staff (umanizza il brand)</li>
            <li><strong>Storia:</strong> Da quanto esiste, filosofia culinaria</li>
          </ul>
        </>
      )
    }
  ],

  threeBoxes: [
    {
      number: '1',
      title: 'Sito Base (€1.200-€2.000)',
      content: (
        <>
          <p id="costi">4-5 pagine essenziali:</p>
          <ul>
            <li>Homepage</li>
            <li>Menu digitale</li>
            <li>Chi siamo</li>
            <li>Contatti/Prenotazioni</li>
            <li>Gallery</li>
          </ul>
        </>
      )
    },
    {
      number: '2',
      title: 'Sito Completo (€2.500-€4.000)',
      content: (
        <>
          <p>Tutto incluso + funzionalità extra:</p>
          <ul>
            <li>Blog/News</li>
            <li>Newsletter</li>
            <li>Sistema prenotazioni avanzato</li>
            <li>Recensioni integrate</li>
          </ul>
        </>
      )
    },
    {
      number: '3',
      title: 'Con E-commerce (€4.000-€8.000)',
      content: (
        <>
          <p>Per asporto e delivery:</p>
          <ul>
            <li>Ordini online</li>
            <li>Pagamenti integrati</li>
            <li>Gestione delivery</li>
            <li>Gift card digitali</li>
          </ul>
        </>
      )
    }
  ],

  twoColumnSections: [
    {
      left: (
        <>
          <h3 id="avanzate">Funzionalità Avanzate (Opzionali)</h3>
          <ul>
            <li><strong>Ordini online:</strong> Per asporto e delivery</li>
            <li><strong>Gift card digitali:</strong> Per regali e occasioni</li>
            <li><strong>Blog/News:</strong> Eventi, nuovi piatti, serate a tema</li>
            <li><strong>Newsletter:</strong> Per fidelizzare i clienti</li>
            <li><strong>Recensioni:</strong> Widget Google/TripAdvisor</li>
            <li><strong>Multilingua:</strong> Per zone turistiche</li>
          </ul>
        </>
      ),
      right: (
        <>
          <h3>Costi Aggiuntivi</h3>
          <ul>
            <li><strong>Dominio:</strong> €10-20/anno (es. nomeristorante.it)</li>
            <li><strong>Hosting:</strong> €50-150/anno</li>
            <li><strong>Fotografie professionali:</strong> €300-800</li>
            <li><strong>Manutenzione:</strong> €50-150/mese (opzionale)</li>
          </ul>
        </>
      )
    },
    {
      left: (
        <>
          <h3 id="seo">SEO Locale: Farsi Trovare</h3>
          <ol>
            <li><strong>Google Business Profile:</strong> Crea e ottimizza la scheda Google</li>
            <li><strong>Keyword locali:</strong> "ristorante + città", "pizzeria + quartiere"</li>
            <li><strong>NAP consistente:</strong> Nome, Indirizzo, Telefono identici ovunque</li>
            <li><strong>Recensioni:</strong> Incoraggia i clienti a lasciare recensioni</li>
            <li><strong>Schema markup:</strong> Dati strutturati per ristoranti</li>
          </ol>
        </>
      ),
      right: (
        <div className="info-box highlight">
          <h3>Priorità SEO</h3>
          <p>
            Concentrati prima su <strong>Google Business Profile</strong>: è gratuito e porta più risultati di qualsiasi altra attività SEO. Un profilo completo può <strong>raddoppiare la tua visibilità locale</strong>.
          </p>
        </div>
      )
    }
  ],

  infoBoxContent: (
    <>
      <h2>Errori da Evitare</h2>
      <div className="info-box">
        <ul>
          <li><strong>Menu in PDF non leggibile:</strong> Usa menu HTML navigabili e responsive</li>
          <li><strong>Sito non mobile-friendly:</strong> Il 70% delle ricerche "ristorante" è da smartphone</li>
          <li><strong>Informazioni obsolete:</strong> Orari, menu e prezzi devono essere sempre aggiornati</li>
          <li><strong>Nessuna call-to-action:</strong> Deve essere facile prenotare o chiamare</li>
          <li><strong>Foto di bassa qualità:</strong> Meglio nessuna foto che foto brutte</li>
          <li><strong>Sito lento:</strong> Se non carica in 3 secondi, il cliente va altrove</li>
        </ul>
      </div>
    </>
  ),

  conclusionContent: (
    <>
      <p>
        Un <strong>sito web professionale per ristorante</strong> non è un costo, è un investimento. Ti permette di essere trovato, di mostrare la tua qualità e di ricevere prenotazioni dirette senza commissioni.
      </p>
      <p>
        Non serve un sito complicato: servono le <strong>funzionalità giuste</strong>, un design appetitoso e informazioni sempre aggiornate. Parti dalle basi e aggiungi funzionalità nel tempo.
      </p>
    </>
  ),

  ctaBox: {
    title: 'Vuoi un Sito Web per il Tuo Ristorante?',
    description: 'Realizzo siti web per ristoranti, pizzerie e attività food. Contattami per un preventivo personalizzato.',
    buttonText: 'Richiedi Preventivo Gratuito'
  },

  relatedPosts: [
    {
      slug: 'quanto-costa-sito-web-professionale-2025',
      title: 'Quanto costa un sito web professionale nel 2025?',
      category: 'Prezzi e Costi',
      readTime: '8 min'
    },
    {
      slug: 'landing-page-efficace-come-convertire',
      title: 'Landing Page Efficace: Come Convertire Visitatori in Clienti',
      category: 'Conversioni',
      readTime: '10 min'
    },
    {
      slug: 'come-scegliere-web-designer-freelance',
      title: 'Come Scegliere un Web Designer Freelance',
      category: 'Guida Pratica',
      readTime: '7 min'
    }
  ]
};

function SitoWebRistoranti() {
  return <BlogArticleTemplate {...articleData} />;
}

export default SitoWebRistoranti;
